<template>
  <div class="mc-dashboard">
    <ManagementFilter
      @updateFleetGroups="updateFleetGroups"
      @updateFleetTypes="updateFleetTypes"
      @updatePeriod="updatePeriod"
      @updateBranches="updateBranches"
    />

    <draggable v-model="layoutOrder" draggable=".mc-drag--dashboard">
      <b-col
        v-for="layout in layoutOrder"
        :key="layout.key"
        :sm="layout.sm"
        :md="layout.md"
        class="drag-item"
      >
        <SummaryFleet
          v-if="layout.key == 'summary-fleet'"
          ref="summaryFleet"
          :fleet-groups="fleetGroups"
          :fleet-types="fleetTypes"
          :main-period="period"
          :branches="branches"
        />

        <AnalysisInfo
          v-if="layout.key == 'trip-analytic' && hasAccess(['a7b-trip-analysis:read'])"
          ref="analysisInfo"
          :fleet-groups="fleetGroups"
          :fleet-types="fleetTypes"
          :main-period="period"
          :branches="branches"
        />
      </b-col>
    </draggable>
  </div>
</template>

<script>
import appConfig from '@/app.config'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'

import draggable from 'vuedraggable'
import { MixPanel } from '@/mixin/mixpanel'
import moment from 'moment'

import SummaryFleet from '../components/SummaryFleet'
import AnalysisInfo from '../components/AnalysisInfo'
import ManagementFilter from './management/ManagementFilter.vue'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Dashboard',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    draggable,
    SummaryFleet,
    ManagementFilter,
    AnalysisInfo,
  },
  mixins: [Helper, MixPanel],

  data() {
    return {
      layoutOrder: [
        { key: 'summary-fleet', md: 12, sm: 12, order: 1 },
        { key: 'trip-analytic', md: 12, sm: 12, order: 2 },
      ],
      phaseOneShow: false,
      fleetGroups: [],
      isLayoutEdit: false,
      pembaruan: {
        key: '0',
        label: this.$t('dashboard.label.disable'),
      },
      refreshInterval: null,
      totalChartData: {
        distance: {
          labels: [],
          datasets: [],
        },
        minutes: {
          labels: [],
          datasets: [],
        },
      },
      period: '',
      fleetTypes: [],
      branches: [],
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return this.$t('menuitems.dashboards.text')
    },

    refreshTimeOption() {
      return [
        { key: 2, label: `2 ${this.$t('global.time.minutes')}` },
        { key: 5, label: `5 ${this.$t('global.time.minutes')}` },
        { key: 10, label: `10 ${this.$t('global.time.minutes')}` },
        { key: 0, label: this.$t('dashboard.label.disable') },
      ]
    },
  },

  mounted() {
    this.period = moment().format('YYYY-MM-DD')
  },

  methods: {
    changeRefreshTime(data) {
      clearInterval(this.timer)
      this.refreshAll()

      localStorage.setItem('dashboard-config', JSON.stringify({ refreshTime: data }))
    },

    async refreshAll() {
      if (this.pembaruan.key != 0) {
        this.refreshInterval = setInterval(() => {
          this.$refs.summaryFleet.$apollo.queries.tripsStatistic.refetch()
        }, 60000 * Number(this.pembaruan.key))
      }
    },

    updateFleetGroups(fleetGroups) {
      this.fleetGroups = fleetGroups
    },
    updateFleetTypes(fleetTypes) {
      this.fleetTypes = fleetTypes
    },
    editLayout() {
      this.isLayoutEdit = true
      let elements = document.querySelectorAll('.drag-item')
      elements.forEach(function (element) {
        element.classList.add('mc-drag--dashboard')
      })
    },
    saveLayout() {
      let elements = document.querySelectorAll('.drag-item')
      elements.forEach(function (element) {
        element.classList.remove('mc-drag--dashboard')
      })
      let newOrder = []
      this.layoutOrder.forEach(function (item, index) {
        newOrder.push({
          ...item,
          order: index + 1,
        })
      })

      this.layoutOrder = newOrder
      localStorage.setItem('dashboard-fuel-layout', JSON.stringify(newOrder))
      this.isLayoutEdit = false
    },
    cancelEditLayout() {
      this.layoutOrder = this.layoutOrder.sort(function (a, b) {
        if (a.order < b.order) return -1
        if (a.order > b.order) return 1
        return 0
      })
      let elements = document.querySelectorAll('.drag-item')
      elements.forEach(function (element) {
        element.classList.remove('mc-drag--dashboard')
      })
      this.isLayoutEdit = false
    },
    updatePeriod(period) {
      this.period = period
    },
    updateBranches(branch) {
      this.branches = branch
    },
  },
}
</script>
